import type { Language } from '@luna/i18n';

const VANILLA_PATH_NAME = 'vanilla.html';

export const isVanillaApp = (): boolean => window.location.pathname.endsWith(VANILLA_PATH_NAME);

export const handleLanguageChange = (language: Language, currentLanguage: string | Language) => {
    const urlParams = new URLSearchParams(window.location.search);

    if (language === currentLanguage) {
        return;
    }

    urlParams.set('lang', language);
    window.location.search = urlParams.toString();
};

export const switchToVanilla = (): void => {
    window.location.pathname = VANILLA_PATH_NAME;
};

export const switchToDefault = (): void => {
    window.location.pathname = '';
};
